module.exports = __webpack_public_path__ + "img/P64-en.87e4ffef.png";